import { useState, useEffect } from 'react'

/**
 * Hook to countdown to midnight UTC (when voting resets)
 * Returns time remaining in hours, minutes, and seconds
 */
export function useCountdown() {
  const [timeRemaining, setTimeRemaining] = useState<{
    hours: number
    minutes: number
    seconds: number
    totalSeconds: number
  }>({ hours: 0, minutes: 0, seconds: 0, totalSeconds: 0 })

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date()
      const tomorrow = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0, 0, 0, 0
      ))
      
      const diff = tomorrow.getTime() - now.getTime()
      const totalSeconds = Math.floor(diff / 1000)
      
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      
      setTimeRemaining({ hours, minutes, seconds, totalSeconds })
    }

    // Calculate immediately
    calculateTimeRemaining()
    
    // Update every second
    const interval = setInterval(calculateTimeRemaining, 1000)
    
    return () => clearInterval(interval)
  }, [])

  return timeRemaining
}

